import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const bcm = {
  namespaced: true,

  state: {
    // 是否显示右边的提示栏
    show: false,
    // 决定显示那个提示栏
    showWhat: "",
    // 发现灾难的人员身份
    observerRole: [{
        role: "监控值班人员发现",
        status: true
      },
      {
        role: "机房内作业人员发现",
        status: false
      },
      {
        role: "网络管理员发现",
        status: false
      },
      {
        role: "系统管理员发现",
        status: false
      },
      {
        role: "应用管理员发现",
        status: false
      },
      {
        role: "其他人员发现",
        status: false
      },
      {
        role: "外部第三方通报",
        status: false
      },
    ],
    datacenter_origin: '',
    factor_origin: '',
    scene_origin: '',
    activity_origin: "",
    activity_updown_origin: "",
    incidentInitialInfo: ''
  },

  mutations: {
    showHints: (state, para) => {
      Vue.set(state, 'show', para.show)
      Vue.set(state, 'showWhat', para.showWhat)
      Vue.set(state, 'info', para.info)
    },
    setObserver: (state, para) => {
      for (let i = 0; i < state.observerRole.length; i++) {
        if (state.observerRole[i].role == para) {
          Vue.set(state.observerRole[i], "status", true)
        } else {
          Vue.set(state.observerRole[i], "status", false)
        }
      }
    },
    setDatacenterOrigin: (state, par) => {
      Vue.set(state, 'datacenter_origin', par)
    },
    setFactorOrigin: (state, par) => {
      Vue.set(state, 'factor_origin', par)
    },
    setSceneOrigin: (state, par) => {
      Vue.set(state, 'scene_origin', par)
    },
    setActivityOrigin: (state, par) => {
      Vue.set(state, 'activity_origin', par)
    },
    setActivityUpDownOrigin: (state, par) => {
      Vue.set(state, 'activity_updown_origin', par)
    },
    setDatacenter: (state, par) => {
      Vue.set(state.datacenter_origin[par + 1], "status", !state.datacenter_origin[par + 1].status)
    },
    setFactor: (state, par) => {
      Vue.set(state.factor_origin[par + 1], "status", !state.factor_origin[par + 1].status)
    },
    setScene: (state, par) => {
      Vue.set(state.scene_origin[par + 1], "status", !state.scene_origin[par + 1].status)
    },
    setincidentInitialInfo: (state, par) => {
      Vue.set(state, "incidentInitialInfo", par)
    },
  },

  actions: {
    // 显示右边栏
    showHints: (context, para) => {
      context.commit("showHints", para)
    },
    // 设置灾难发现人员
    setObserver: (context, para) => {
      context.commit("setObserver", para)
    },
    setDatacenterOrigin: (context, par) => {
      context.commit('setDatacenterOrigin', par)
    },
    setFactorOrigin: (context, par) => {
      context.commit('setFactorOrigin', par)
    },
    setSceneOrigin: (context, par) => {
      context.commit('setSceneOrigin', par)
    },
    setActivityOrigin: (context, par) => {
      context.commit('setActivityOrigin', par)
    },
    setActivityUpDownOrigin: (context, par) => {
      context.commit('setActivityUpDownOrigin', par)
    },
    setDatacenter: (context, par) => {
      context.commit('setDatacenter', par)
    },
    setFactor: (context, par) => {
      context.commit('setFactor', par)
    },
    setScene: (context, par) => {
      context.commit('setScene', par)
    },
    setincidentInitialInfo: (context, par) => {
      context.commit('setincidentInitialInfo', par)
    },
  }
}